import { _ as _extends } from '../_rollupPluginBabelHelpers-e8fb2e5c.js';
import React__default, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { c as classnames } from '../index-6ff23041.js';
import { b as badgeConfig } from '../configs-fed6ac34.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "[data-gene-ui-version=\"2.13.0\"] .badge{max-width:-webkit-fit-content;max-width:-moz-fit-content;max-width:fit-content;position:relative}[data-gene-ui-version=\"2.13.0\"] .badge__content{background:var(--danger);border-radius:3rem;color:var(--danger-sc);display:block;font:600 1rem/1.6rem var(--font-family);min-width:1.6rem;padding:0 .5rem;text-align:center}[data-gene-ui-version=\"2.13.0\"] .badge__content-children{position:absolute;top:-.8rem}html:not([dir=rtl]) .badge__content-children{right:-.8rem}html[dir=rtl] .badge__content-children{left:-.8rem}[data-gene-ui-version=\"2.13.0\"] .badge__content-dot{height:1rem;min-height:1rem;min-width:1rem;top:-.5rem;width:1rem}html:not([dir=rtl]) .badge__content-dot{right:-.5rem}html[dir=rtl] .badge__content-dot{left:-.5rem}[data-gene-ui-version=\"2.13.0\"] .badge__content-medium{line-height:1.8rem;min-height:1.8rem;min-width:1.8rem}[data-gene-ui-version=\"2.13.0\"] .badge__content-big{line-height:2.2rem;min-height:2.2rem;min-width:2.2rem}[data-gene-ui-version=\"2.13.0\"] .badge__content-huge{font-size:1.3rem;line-height:2.6rem;min-height:2.6rem;min-width:2.6rem}[data-gene-ui-version=\"2.13.0\"] .badge__content-big,[data-gene-ui-version=\"2.13.0\"] .badge__content-huge,[data-gene-ui-version=\"2.13.0\"] .badge__content-medium{top:-1rem}html:not([dir=rtl]) .badge__content-big,html:not([dir=rtl]) .badge__content-huge,html:not([dir=rtl]) .badge__content-medium{right:-1rem}html[dir=rtl] .badge__content-big,html[dir=rtl] .badge__content-huge,html[dir=rtl] .badge__content-medium{left:-1rem}[data-gene-ui-version=\"2.13.0\"] .badge__content-primary{background:var(--hero)}";
styleInject(css_248z);

const getShowValue = (count, maxCount) => {
  if (count !== 0 && !count) return null;
  if (!maxCount) return count;
  return count > maxCount ? "".concat(maxCount, "+") : count;
};
function Badge(_ref) {
  let {
    children,
    size,
    color,
    count,
    dot,
    maxCount,
    className,
    ...restProps
  } = _ref;
  const show = useMemo(() => dot ? '' : getShowValue(count, maxCount), [dot, count, maxCount]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: "badge"
  }, restProps), show !== null && /*#__PURE__*/React__default.createElement("span", {
    className: classnames('badge__content', className, {
      ["badge__content-".concat(size)]: size,
      ["badge__content-".concat(color)]: color,
      ["badge__content-dot"]: dot,
      ["badge__content-children"]: children
    })
  }, show), children);
}
Badge.propTypes = {
  /**
   * Any valid React node
   */
  children: PropTypes.node,
  /**
   * Any custom class name
   */
  className: PropTypes.string,
  /**
   * Badge size
   */
  size: PropTypes.oneOf(badgeConfig.size),
  /**
   * Badge color
   */
  color: PropTypes.oneOf(badgeConfig.color),
  /**
   * Shows the specified number on the badge
   */
  count: PropTypes.number,
  /**
   * Set this property to have only dot instead of number
   */
  dot: PropTypes.bool,
  /**
   * When the "count" is greater than "maxCount" Badge will show "maxCount" value and "+"
   */
  maxCount: PropTypes.number
};
Badge.defaultProps = {
  dot: false,
  size: badgeConfig.size[0],
  color: badgeConfig.color[0]
};

export { Badge as default };
